import { ChangeDetectionStrategy, Component, afterNextRender, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BROWSER_STORAGE } from '../../core/platform/browser-storage';

export const COOKIE_NOTICE_KEY = 'mypt-cookie-notice';

/// Onay toplamayan bilgilendirme bandı (docs/legal/drafts/06 "A varyantı";
/// sitede analitik/reklam yok). Layout akışının SONUNDA `sticky bottom-0`:
/// kaydırırken ekranın altına yapışır, sayfa sonunda alt bilginin altına
/// oturur — içerik örtülmez, bandın yüksekliği kadar yer akışta ayrılır.
/// İlk boyamadan sonra eklenir; görünür içeriği kaydırmaz (CLS yok).
@Component({
    selector: 'site-cookie-banner',
    imports: [RouterLink],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
    @if (visible()) {
      <div
        role="region"
        aria-label="Çerez bilgilendirmesi"
        class="sticky bottom-0 z-30 border-0 border-t border-solid border-surface-line bg-white pb-[env(safe-area-inset-bottom)] shadow-[0_-8px_24px_rgba(20,33,31,0.08)]"
        data-test="cookie-banner"
      >
        <div class="site-container flex flex-col gap-[0.75rem] py-[1rem] sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <p class="text-sm text-ink-muted">
            Bu sitede reklam veya ziyaretçi takibi çerezi kullanmıyoruz. Yalnızca oturumunuzun açık kalması ve sitenin
            çalışması için gerekli tarayıcı depolama alanlarını kullanıyoruz. Ayrıntılar:
            <a routerLink="/cerez-politikasi" class="font-semibold">Çerez Politikası</a> ve
            <a routerLink="/kvkk" class="font-semibold">KVKK Aydınlatma Metni</a>.
          </p>
          <button type="button" class="site-btn site-btn--primary shrink-0" (click)="dismiss()" data-test="cookie-ok">Tamam</button>
        </div>
      </div>
    }
  `
})
export class CookieBannerComponent {
  private readonly storage = inject(BROWSER_STORAGE);
  readonly visible = signal(false);

  constructor() {
    afterNextRender(() => this.visible.set(this.storage.getItem(COOKIE_NOTICE_KEY) !== '1'));
  }

  dismiss(): void {
    this.storage.setItem(COOKIE_NOTICE_KEY, '1');
    this.visible.set(false);
  }
}
